export default {
  title: 'Meniu nou',
  headers: {
    edit_time: 'Editează ora',
  },
  labels: {
    select_all: 'Selectează tot',
  },
  fields: {
    name: {
      label: 'Nume',
      placeholder: 'Introdu numele meniului',
    },
    sorting_order: {
      label: 'Ordinea de afișare a meniului',
      placeholder: 'Introdu ordinea de afișare a meniului',
    },
    has_separate_schedule: {
      label: 'Diferit de orele de deschidere obișnuite',
    },
    selected_days: {
      label: 'Zile selectate',
    },
    opening_time: {
      label: 'Oră de deschidere',
    },
    closing_time: {
      label: 'Oră de închidere',
    },
  },
  buttons: {
    add_opening_time: 'Adaugă oră de deschidere',
    add: 'Adaugă',
    cancel: 'Anulează',
    save: 'Salvează',
    close: 'Închide',
  },
  feedback: {
    missing_info: 'Informații lipsă',
  },
  toasts: {
    menu_got_created: 'Meniul a fost creat',
    menu_got_updated: 'Meniul a fost actualizat',
  },
};
